/** global process */
export const MOGAMBO_VERSION = process.env.APP_VERSION;
export const SENTRY_REPORTING_URL =
  'https://e056e71d4f3049d3b4b14bc9b0797ef4@o225877.ingest.sentry.io/5239237';
export const SENTRY_ENVIRONMENTS_ALLOWED = ['staging', 'production'];
export const SDK_LOADER_URL =
  'https://toolassets.haptikapi.com/platform/javascript-xdk/production/loader.js';

export const EventTypes = {
  ENTITY_DATA_UPDATED: 'ENTITY_DATA_UPDATED',
  ENTITY_FOR_EDIT_UPDATED: 'ENTITY_FOR_EDIT_UPDATED',
  UPDATE_GRAPH: 'UPDATE_GRAPH',
  SHALLOW_UPDATE_GRAPH: 'SHALLOW_UPDATE_GRAPH',
};

export const { MIX_PANEL_TOKEN_MOGAMBO } = process.env;

// Feature Flags
export const FEATURE_FLAG_DATA = {
  FLAGS: {
    ENABLE_AB_TESTING: 'enable_ab_testing',
    ENABLE_TRANSFER_OVERRIDE: 'enable_transfer_override',
    DISABLE_LANGUAGE_GUARDRAILS: 'disable_language_guardrails',
    ENABLE_REPHRASE_RESPONSES: 'enable_rephrase_responses',
    ENABLE_AGENT_FEEDBACK_MESSAGES: 'enable_dedicated_agent_feedback_flow',
    ENABLE_WEBGUIDE: 'enable_webguide',
    ENABLE_CORS_HEADER_ORIGIN: 'enable_cors_header_origin',
    ENABLE_GEN_AI_SALES_ASSISTANT: 'enable_gen_ai_sales_assistant',
    ENABLE_CONTEXTUAL_BOT_BREAK: 'enable_contextual_bot_break',
  },
  TYPES: {
    DOMAIN: 'domain',
    PARTNER: 'partner',
    BUSINESS: 'business',
  },
};

// Meant for Hinglish
export const HINDI_SCRIPT_CODES = {
  HINGLISH: 'latn',
  DEVANAGARI: 'hi',
};

export const HINDI_SCRIPTS = [
  {
    script: HINDI_SCRIPT_CODES.HINGLISH,
    title: 'Hinglish',

    // For BM
    name: 'Hindi - Latin',
    language_code: HINDI_SCRIPT_CODES.HINGLISH,
    language_src: HINDI_SCRIPT_CODES.HINGLISH,
  },
  {
    script: HINDI_SCRIPT_CODES.DEVANAGARI,
    title: 'Devanagari',

    // For BM
    name: 'Hindi - Devanagari',
    language_code: HINDI_SCRIPT_CODES.DEVANAGARI,
    language_src: HINDI_SCRIPT_CODES.DEVANAGARI,
  },
];

export const HYBRID_LANGUAGES = {
  en: [],
  hi: HINDI_SCRIPTS,
};

export const AlertTimeout = 3000;
export const AlertTypes = {
  NEGATIVE: 'NEGATIVE',
  POSITIVE: 'POSITIVE',
  WARNING: 'WARNING',
};

export const TEMPLATE_CATEGORIES = [
  {
    title: 'Generic',
    value: 'Generic',
  },
  {
    title: 'Customer Support',
    value: 'Customer Support',
  },
  {
    title: 'Banking Sector',
    value: 'Banking Sector',
  },
  {
    title: 'Feedback',
    value: 'Feedback',
  },
  {
    title: 'Ecommerce',
    value: 'Ecommerce',
  },
  {
    title: 'Insurance',
    value: 'Insurance',
  },
  {
    title: 'Telecom',
    value: 'Telecom',
  },
  {
    title: 'Integrations',
    value: 'Integrations',
  },
  {
    title: 'Mortgage',
    value: 'Mortgage',
  },
  {
    title: 'Media & Entertainment',
    value: 'Media & Entertainment',
  },
];

// Context Clear
export const CONTEXT_CLEAR_NODE = {
  KEY: 'context_clear',
  VALUE: 'Context Clear Step',
  NODE_GRAPH_DENOTION: 'C',
};

// End of Query
export const END_OF_QUERY = {
  KEY: 'query_end',
  VALUE: 'End of Query',
  NODE_GRAPH_DENOTION: 'E',
};

// Language
export const DEFAULT_LANGUAGE = 'en';

// Bot Says
export const BotSaysKeys = {
  STATIC_NODE: {
    DELAY: 'delay',
    ENTITIES: 'entities',
    TIME: 'time',
    ADD: 'add',
    DELETE: 'delete',
    SORT: 'sort',
    MANDATORY: 'mandatory',
    FLUSH_ENTITIES: 'flushEntities',
  },
  DYNAMIC_NODE: {
    VARIANTS: 'variants',
    DEVICE_PLATFORM_MAP: 'devicePlatformMap',
    ENTITIES: 'entities',
  },
};

export const ActionTypes = {
  // Feature Flag
  SET_FEATURE_FLAG: 'SET_FEATURE_FLAG',

  // All Bots Data:
  RECEIVE_ALL_BOTS: 'RECEIVE_ALL_BOTS',
  SET_DROPPABLE: 'SET_DROPPABLE',

  // Bot Actions
  CREATE_BOT_FAILED: 'CREATE_BOT_FAILED',
  CREATE_BOT_SUCCESS: 'CREATE_BOT_SUCCESS',
  CREATE_BOT: 'CREATE_BOT',
  DEPLOY_BOT: 'DEPLOY_BOT',
  FETCH_BOT_TEST_CONFIG_FAILED: 'FETCH_BOT_TEST_CONFIG_FAILED',
  FETCH_BOT_TEST_CONFIG_SUCCESS: 'FETCH_BOT_TEST_CONFIG_SUCCESS',
  FETCH_BOT_TEST_CONFIG: 'FETCH_BOT_TEST_CONFIG',
  RECEIVE_DEPLOY_BOT: 'RECEIVE_DEPLOY_BOT',
  RECEIVE_BOT_DATA: 'RECEIVE_BOT_DATA',
  UPDATE_BOT: 'UPDATE_BOT',
  UPDATE_BOT_FAILED: 'UPDATE_BOT_FAILED',
  UPDATE_CREATE_BOT_MODAL_STATUS: 'UPDATE_CREATE_BOT_MODAL_STATUS',
  SET_RHS_ACTIVE: 'SET_RHS_ACTIVE',
  SET_GLOBAL_CONSTANT_DRAWER_REF: 'SET_GLOBAL_CONSTANT_DRAWER_REF',

  // Story Actions
  FETCH_ALL_STORIES: 'FETCH_ALL_STORIES',
  UPDATE_STORIES: 'UPDATE_STORIES',
  RECEIVE_ALL_STORIES_SUCCESS: 'RECEIVE_ALL_STORIES_SUCCESS',
  RECEIVE_ALL_STORIES_FAILED: 'RECEIVE_ALL_STORIES_FAILED',
  SET_CURRENT_SUBSTORY_ID: 'SET_CURRENT_SUBSTORY_ID',

  // Sub Story Actions
  UPDATE_SUB_STORIES: 'UPDATE_SUB_STORIES',

  // Bot Level Overlay Data
  GET_GENERAL_RESPONSES: 'GET_GENERAL_RESPONSES',
  GET_NODE_PRIORITY: 'GET_NODE_PRIORITY',
  SET_GLOBAL_CONSTANTS_DRAWER_ACTIVE: 'SET_GLOBAL_CONSTANTS_DRAWER_ACTIVE',

  // AB TEST
  SET_AB_TESTING_DRAWER_ACTIVE: 'SET_AB_TESTING_DRAWER_ACTIVE',
  SET_AB_TESTING_RHS_STATE: 'SET_AB_TESTING_RHS_STATE',
  SET_STEP_SELECTED_FOR_AB_TESTING: 'SET_STEP_SELECTED_FOR_AB_TESTING',
  SET_AB_TEST_INFO: 'SET_AB_TEST_INFO',
  SET_AB_TEST_MODIFIED_FLAG: 'SET_AB_TEST_MODIFIED_FLAG',

  // GenAI
  SET_GEN_AI_MODAL_ACTIVE: 'SET_GEN_AI_MODAL_ACTIVE',

  // Business
  RECEIVED_BUSINESS_LIST: 'RECEIVED_BUSINESS_LIST',
  TOGGLE_BUSINESS_LIST_LOADING: 'TOGGLE_BUSINESS_LIST_LOADING',

  // Api/Partner Response
  PARTNER_RESPONSE_RECEIVED: 'PARTNER_RESPONSE_RECEIVED',
  UPDATE_PARTNER_RESPONSES: 'UPDATE_PARTNER_RESPONSES',
  SEND_PARTNER_RESPONSES: 'SEND_PARTNER_RESPONSES',

  // User Responses
  RECEIVE_USER_RESPONSES: 'RECEIVE_USER_RESPONSES',
  UPDATE_USER_RESPONSES: 'UPDATE_USER_RESPONSES',
  UPDATE_NEGATIVE_USER_RESPONSES: 'UPDATE_NEGATIVE_USER_RESPONSES',

  // Disambiguation Texts
  RECEIVE_DISAMBIGUATION_TEXTS: 'RECEIVE_DISAMBIGUATION_TEXTS',
  UPDATE_DISAMBIGUATION_TEXTS: 'UPDATE_DISAMBIGUATION_TEXTS',

  // Truth Table/Bot Responses
  UPDATE_NODE_DELAY_MESSAGE: 'UPDATE_NODE_DELAY_MESSAGE',

  // General Actions
  CREATE_ALERT: 'CREATE_ALERT',
  OPEN_CONFIRMATION_DIALOG: 'OPEN_CONFIRMATION_DIALOG',
  CLOSE_CONFIRMATION_DIALOG: 'CLOSE_CONFIRMATION_DIALOG',

  // General Nodes
  SET_GENERAL_NODES: 'SET_GENERAL_NODES',
  UPDATE_GENERAL_NODES: 'UPDATE_GENERAL_NODES',

  // Node summary information
  SET_NODE_SUMMARY: 'SET_NODE_SUMMARY',

  // Synonyms
  GET_SYNONYMS: 'GET_SYNONYMS',
  SET_SYNONYMS: 'SET_SYNONYMS',
  GET_MEANINGS: 'GET_MEANINGS',
  SET_MEANINGS: 'SET_MEANINGS',
  UPDATE_SYNONYMS: 'UPDATE_SYNONYMS',
  UPDATE_ENTITIES: 'UPDATE_ENTITIES',
  UPDATED_MEANINGS: 'UPDATED_MEANINGS',
  SEND_SYNONYMS: 'SEND_SYNONYMS',
  RECEIVE_MEANINGS: 'RECEIVE_MEANINGS',

  OPEN_COMPONENT_MODAL: 'OPEN_COMPONENT_MODAL',
  UPDATE_COMPONENT_MODAL: 'UPDATE_COMPONENT_MODAL',
  CLOSE_COMPONENT_MODAL: 'CLOSE_COMPONENT_MODAL',
  LOADING_COMPONENT_MODAL: 'LOADING_COMPONENT_MODAL',

  // Entities
  SEND_ENTITIES: 'SEND_ENTITIES',
  UPDATE_ENTITY: 'UPDATE_ENTITY',
  UPDATED_USER_SAYS_ENTITIES: 'UPDATED_USER_SAYS_ENTITIES',
  FETCH_ENTITY_DATA_STARTED: 'FETCH_ENTITY_DATA_STARTED',
  FETCH_ENTITY_DATA_FAILED: 'FETCH_ENTITY_DATA_FAILED',
  FETCH_ENTITY_DATA_SUCCESS: 'FETCH_ENTITY_DATA_SUCCESS',
  CLEAR_ENTITY_DATA: 'CLEAR_ENTITY_DATA',
  UPDATE_ENTITY_DATA_STARTED: 'UPDATE_ENTITY_DATA_STARTED',
  UPDATE_ENTITY_DATA_SUCCESS: 'UPDATE_ENTITY_DATA_SUCCESS',
  UPDATE_ENTITY_DATA_FAILED: 'UPDATE_ENTITY_DATA_FAILED',
  UPDATE_ENTITY_DATA_SAVED: 'UPDATE_ENTITY_DATA_SAVED',
  UPDATE_ENTITY_LANGUAGES: 'UPDATE_ENTITY_LANGUAGES',

  // Bot responses
  SET_BOT_RESPONSES: 'SET_BOT_RESPONSES',
  UPDATE_BOT_RESPONSES: 'UPDATE_BOT_RESPONSES',
  BOT_RESPONSES_RECEIVED: 'BOT_RESPONSES_RECEIVED',
  SAVE_BOT_RESPONSES: 'SAVE_BOT_RESPONSES',
  SET_CURRENT_BOTSAYS_LANGUAGE: 'SET_CURRENT_BOTSAYS_LANGUAGE',
  RESET_BOT_RESPONSE_UPDATE_DATA: 'RESET_BOT_RESPONSE_UPDATE_DATA',
  SET_IS_SUPERMAN: 'SET_IS_SUPERMAN',
  SET_CURRENT_CHANNEL_ID: 'SET_CURRENT_CHANNEL_ID',
  UPDATE_BOT_RESPONSES_BY_CHANNEL: 'UPDATE_BOT_RESPONSES_BY_CHANNEL',

  // Templates
  FETCH_TEMPLATES: 'FETCH_TEMPLATES',
  FETCH_TEMPLATES_SUCCESS: 'FETCH_TEMPLATES_SUCCESS',
  FETCH_TEMPLATES_FAILED: 'FETCH_TEMPLATES_FAILED',
  CREATE_TEMPLATES: 'CREATE_TEMPLATES',
  CREATE_TEMPLATES_SUCCESS: 'CREATE_TEMPLATES_SUCCESS',
  CREATE_TEMPLATES_FAILED: 'CREATE_TEMPLATES_FAILED',
  UPDATE_TEMPLATES_SUCCESS: 'UPDATE_TEMPLATES_SUCCESS',
  UPDATE_TEMPLATES_FAILED: 'UPDATE_TEMPLATES_FAILED',
  UPDATE_CREATE_TEMPLATE_MODAL_STATUS: 'UPDATE_CREATE_TEMPLATE_MODAL_STATUS',
  FETCH_TEMPLATE_DATA: 'FETCH_TEMPLATE_DATA',
  FETCH_TEMPLATE_DATA_SUCCESS: 'FETCH_TEMPLATE_DATA_SUCCESS',
  FETCH_TEMPLATE_DATA_FAILED: 'FETCH_TEMPLATE_DATA_FAILED',
  UPDATE_TEMPLATE_DATA: 'UPDATE_TEMPLATE_DATA',
  ADD_TEMPLATE_TO_BOT_SUCCESS: 'ADD_TEMPLATE_TO_BOT_SUCCESS',
  ADD_TEMPLATE_TO_BOT_FAILED: 'ADD_TEMPLATE_TO_BOT_FAILED',

  // Component Tooltip
  OPEN_COMPONENT_TOOLTIP: 'OPEN_COMPONENT_TOOLTIP',
  CLOSE_COMPONENT_TOOLTIP: 'CLOSE_COMPONENT_TOOLTIP',

  // Header
  UPDATE_HEADER_BRANDS: 'UPDATE_HEADER_BRANDS',
  UPDATE_HEADER_ACTIONS: 'UPDATE_HEADER_ACTIONS',

  // Loading
  STOP_LOADING: 'STOP_LOADING',
  START_LOADING: 'START_LOADING',

  // SubStory Routes
  SET_URL_METADATA: 'SET_URL_METADATA',
  SET_NODE_CONNECTIONS: 'SET_NODE_CONNECTIONS',
  UPDATE_NODE_CONNECTIONS: 'UPDATE_NODE_CONNECTIONS',
  UPDATE_STEP_POSITION: 'UPDATE_STEP_POSITION',
  SET_GRAPH: 'SET_GRAPH',
  ENABLE_SAVE: 'ENABLE_SAVE',
  DISABLE_SAVE: 'DISABLE_SAVE',
  RECEIVE_SUBSTORY_GRAPH: 'RECEIVE_SUBSTORY_GRAPH',
  CLEAR_GRAPH: 'CLEAR_GRAPH',
  ADD_NEW_NODE: 'ADD_NEW_NODE',
  ADD_AB_NODE: 'ADD_AB_NODE',
  STEP_CREATED: 'STEP_CREATED',
  FORCE_UPDATE_GRAPH: 'FORCE_UPDATE_GRAPH',
  RESET_EDITED: 'RESET_EDITED',

  // COPY PASTE
  COPY_SUBSTORY: 'COPY_SUBSTORY',
  COPY_SUBSTORY_RESET: 'COPY_SUBSTORY_RESET',
  COPY_NODE: 'COPY_NODE',
  COPY_PASTE_RESET: 'COPY_PASTE_RESET',
  DRAG_NODE: 'DRAG_NODE',
  DROP_NODE: 'DROP_NODE',
  DRAG_DROP_RESET: 'DRAG_DROP_RESET',

  // Language Updates
  UPDATE_CURRENT_LANGUAGE: 'UPDATE_CURRENT_LANGUAGE',
  SET_CURRENT_SCREEN: 'SET_CURRENT_SCREEN',
  ADD_LANGUAGE_TO_BOT_SUCCESS: 'ADD_LANGUAGE_TO_BOT_SUCCESS',
  ADD_LANGUAGE_TO_BOT_FAILED: 'ADD_LANGUAGE_TO_BOT_FAILED',
};

export const SCREEN_TYPES = {
  ALL_BOTS: 'ALL_BOTS',

  ALL_STORIES: 'ALL_STORIES',
  EDIT_STORY: 'EDIT_STORY',

  // Bot Level Overlays
  NODE_PRIORITY: 'NODE_PRIORITY',
  GENERAL_RESPONSES: 'GENERAL_RESPONSES',
  GENERAL_NODES: 'GENERAL_NODES',

  // V2
  HOME: 'HOME',
  STORIES: 'STORIES',
  GRAPH: 'GRAPH',
  BUSINESS_MANAGER: 'BUSINESS_MANAGER',
  SMALLTALK: 'SMALLTALK',
  SEARCH: 'SEARCH',
};

export const SUBSTORY_COLOR_LIST = [
  { primary: '#6B57FF', transparent: '#D2CCFF', secondary: '#FFFFFF' },
  { primary: '#4D761F', transparent: '#C9D5BB', secondary: '#FFFFFF' },
  { primary: '#9D00CF', transparent: '#E1B2F0', secondary: '#FFFFFF' },
  { primary: '#FFCD00', transparent: '#FFF0B2', secondary: '#FFFFFF' },
  { primary: '#FA49C0', transparent: '#FDC8EB', secondary: '#FFFFFF' },
  { primary: '#863535', transparent: '#DAC2C2', secondary: '#FFFFFF' },
  { primary: '#1E7095', transparent: '#BBD4DF', secondary: '#FFFFFF' },
  { primary: '#FF9815', transparent: '#FFDFB8', secondary: '#FFFFFF' },
  { primary: '#FE5555', transparent: '#FECBCB', secondary: '#FFFFFF' },
  { primary: '#1DDDAD', transparent: '#BBF4E6', secondary: '#FFFFFF' },
  { primary: '#B15293', transparent: '#E7CBDE', secondary: '#FFFFFF' },
  { primary: '#1A00CE', transparent: '#BAB2F0', secondary: '#FFFFFF' },
  { primary: '#573160', transparent: '#CCC1CF', secondary: '#FFFFFF' },
  { primary: '#352F6D', transparent: '#C2C0D3', secondary: '#FFFFFF' },
  { primary: '#52AFFF', transparent: '#CAE7FF', secondary: '#FFFFFF' },
  { primary: '#88DD1D', transparent: '#DBF4BB', secondary: '#FFFFFF' },
  { primary: '#FF7F7F', transparent: '#FFD8D8', secondary: '#FFFFFF' },
  { primary: '#006AC9', transparent: '#B2D2EE', secondary: '#FFFFFF' },
  { primary: '#CFDD1D', transparent: '#F0F4BB', secondary: '#FFFFFF' },
  { primary: '#CFA8FF', transparent: '#F0E4FF', secondary: '#FFFFFF' },
  { primary: '#7DFFEE', transparent: '#D7FFF9', secondary: '#FFFFFF' },
  { primary: '#7DFFA4', transparent: '#D8FFE3', secondary: '#FFFFFF' },
];

export const KEY_CODES = {
  ENTER_KEY: 13,
  DOWN_KEY: 40,
  UP_KEY: 38,
  LEFT_KEY: 37,
  RIGHT_KEY: 39,
  ESC_KEY: 27,
};

export const NODE_TYPES = {
  REGULAR: 0,
  BOT_GENERAL: 1,
  STORY_GENERAL: 2,
};

export const GRAPH_NODE_TYPE = {
  STATIC: 'node',
  CODE: 'processing',
  OUTPUT: 'output',
  AB_NODE: 'ab_test',
};

export const GRAPH_NODE_DISPLAY_TEXT = {
  STATIC: 'STATIC',
  CODE: 'CODE',
  OUTPUT: 'OUTPUT',
  AB_NODE: 'AB_NODE',
};

export const CONNECTION_TYPE = {
  STATIC_TO_STATIC: 'node-node',
  STATIC_TO_CODE: 'node-processing',
  CODE_TO_DYNAMIC: 'processing-output',
  DYNAMIC_TO_STATIC: 'output-node',
  STATIC_TO_AB: 'node-ab_test',
  AB_TO_STATIC: 'ab_test-node',
};

export const TEMPLATE_TYPES = {
  BOT_GENERAL_TEMPLATE: 0,
  SUBSTORY_TEMPLATE: 1,
  SUBSTORY_WITH_API_TEMPLATE: 2,
  0: {
    title: 'General Steps',
    iconType: 'template_general',
  },
  1: {
    title: 'Skill',
    iconType: 'template_substory',
  },
  2: {
    title: 'Skill with API',
    iconType: 'template_substory_api',
  },
};

export const BOT_SAYS_EMPTY_MSG_TIMESTAMP = Date.parse(
  '2018-10-02T00:00:00.000000'
);

export const USER_PREFERENCE_STORAGE_KEY = 'mogambo-user-preferences';
export const STORAGE_KEYS = {
  INACTIVE_NODES_VISIBLE: 'INACTIVE_NODES_VISIBLE',
  BOT_LANGUAGE_SCRIPT: 'BOT_LANGUAGE_SCRIPT',
  BOT_LANGUAGE_SOURCE: 'BOT_LANGUAGE_SOURCE',
};

export const MAX_DISAMBIGUATION_MSG_LENGTH = 40;

export const AutoPreviewSupportedChannels = [2, 6, 14];
